export default __webpack_public_path__ + "2fd82e4.png";